// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-teaser-selection{margin-bottom:4rem}@media (min-width:768px){.product-teaser-selection{margin-bottom:8rem}}.section--gray .product-teaser-selection{margin-bottom:2.667rem}@media (min-width:768px){.section--gray .product-teaser-selection{margin-bottom:4.333rem}}.vsa-item__content .section:last-child .product-teaser-selection{margin-bottom:0}@media (min-width:768px){.vsa-item__content .section:last-child .product-teaser-selection{margin-bottom:0}}", ""]);
// Exports
module.exports = exports;
